var map = {
	"./LectumA_1.png": "1d77",
	"./LectumA_2.png": "74f2",
	"./LectumA_3.png": "aea3",
	"./LectumB_1.png": "5f96",
	"./LectumB_2.png": "cab6",
	"./Lectum_icon.png": "c140",
	"./activity.jpg": "6a44",
	"./lesson.jpg": "4def",
	"./loading.gif": "12ae",
	"./logo.png": "9d64",
	"./logo.svg": "e347",
	"./nodata.jpg": "9cc4",
	"./nodata2.jpg": "3b59",
	"./question.jpg": "c893",
	"./text.jpg": "eaea",
	"./undraw_empty_street_sfxm.svg": "0fed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";